/*@flow*/
import type { Node } from 'react'; /** @jsx jsx */
import { jsx } from '@emotion/core';
import Drawer from 'comps/Drawer';
import { isXSmallScreen } from 'lib/getScreenWidth';
import LTPublicData from './LTPublicData';
import LTLayers from './LTLayers';
import LTAnalysis from './LTAnalysis';
import LTFilters from './LTFilters';
import LTLocation from './LTLocation';
import LTTools from './LTTools';
import { narrowButtonBarWidth, useButtonBarWidth } from './LTButtonBar';
import { ltButtonBarBg } from "./colors";
import useContextState from './useContextState';

const componentMap = {
  LOCATION_DETAILS: LTLocation,
  LIST_VIEW: LTLocation, // Alias for LOCATION_DETAILS
  PUBLIC_DATA: LTPublicData,
  FILTERS: LTFilters,
  LAYERS: LTLayers,
  ANALYSIS: LTAnalysis,
  TOOLS: LTTools,
};

function LTActivePanel() {
  const { activePanel } = useContextState();
  if (!activePanel) return null;
  const Panel = componentMap[activePanel];
  if (!Panel) return null;
  return <Panel />;
}

export default function LTDrawer(): Node {
  const { activePanel } = useContextState();
  const isOpen = Boolean(activePanel);
  let width = 0;
  const buttonBarWidth = useButtonBarWidth();
  let backgroundColor = 'white';

  if (isOpen) {
    switch (activePanel) {
      case 'FILTERS':
        width = 410;
        backgroundColor = ltButtonBarBg;
        break;
      case 'LAYERS':
        width = 285;
        backgroundColor = ltButtonBarBg;
        break;
      case 'PUBLIC_DATA':
        width = 410;
        backgroundColor = ltButtonBarBg;
        break;
      case 'LOCATION_DETAILS':
        width = 410;
        backgroundColor = ltButtonBarBg;
        break;
      case 'ANALYSIS':
        width = 410;
        backgroundColor = ltButtonBarBg;
        break;
      case 'TOOLS':
        width = 350;
        backgroundColor = ltButtonBarBg;
        break;
      default:
        break;
    }

    if (isXSmallScreen()) {
      const iw = window.innerWidth;
      width = iw - narrowButtonBarWidth;
    }
  }

  return (
    <Drawer
      docked
      width={width}
      className="drawer"
      open={isOpen}
      containerStyle={{
        color: 'inherit',
        position: 'absolute',
        borderLeft: '1px solid #ccc',
        boxShadow: 'none',
        overflowY: 'auto',
        overflowX: 'hidden',
        left: buttonBarWidth,
        bottom: 0,
        backgroundColor,
        width,
        zIndex: 8,
        overscrollBehavior: 'contain',
        transition:
          'transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, width 200ms',
      }}
    >
      <LTActivePanel />
    </Drawer>
  );
}
